module.exports = __webpack_public_path__ + "img/volaille.bb34534b.jpeg";